/**
 * 日志级别定义
 */
export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  NONE = 99,
}

// 默认配置：生产环境只显示 INFO 及以上
const DEFAULT_CONFIG = {
  level: process.env.NODE_ENV === 'production' ? LogLevel.INFO : LogLevel.DEBUG,
  enableTimestamp: true,
};

class Logger {
  private moduleName: string;

  constructor(moduleName: string) {
    this.moduleName = moduleName;
  }

  private format(level: string, message: string): string[] {
    const timestamp = DEFAULT_CONFIG.enableTimestamp
      ? `[${new Date().toISOString()}]`
      : '';
    return [`${timestamp} [${this.moduleName}] [${level}]`, message];
  }

  debug(message: string, ...args: any[]) {
    if (DEFAULT_CONFIG.level <= LogLevel.DEBUG) {
      console.debug(...this.format('DEBUG', message), ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if (DEFAULT_CONFIG.level <= LogLevel.INFO) {
      console.info(...this.format('INFO', message), ...args);
    }
  }

  warn(message: string, ...args: any[]) {
    if (DEFAULT_CONFIG.level <= LogLevel.WARN) {
      console.warn(...this.format('WARN', message), ...args);
    }
  }

  error(message: string, error?: any) {
    if (DEFAULT_CONFIG.level <= LogLevel.ERROR) {
      console.error(...this.format('ERROR', message), error || '');
      // 扩展点：可以在这里统一上报错误到监控平台 (如 Sentry)
    }
  }
}

/**
 * 创建特定模块的 logger 实例
 * @example const logger = createLogger('PatientService');
 */
export const createLogger = (moduleName: string) => new Logger(moduleName);
